import React from "react";
import { Check, Save } from "@mui/icons-material";
import { Dialog, DialogTitle, CircularProgress, Fab } from "@mui/material";
import {
  ContentDialog,
  BoxDialog,
  CircularProgressCSS,
  ButtonSx,
} from "./style";
import { useTranslation } from "react-i18next";

const UpdateDialog = ({
  success,
  showDialogUpdate,
  setShowDialogUpdate,
  textTittle,
}) => {
  const { t } = useTranslation();
  const handleClose = (e, reason) => {
    if (reason !== "backdropClick") {
      setShowDialogUpdate(false);
    }
  };

  return (
    <div>
      <Dialog
        open={showDialogUpdate}
        onClose={(e, reason) => handleClose(e, reason)}
      >
        <DialogTitle style={{ fontWeight: "bold" }}>{textTittle}</DialogTitle>
        <ContentDialog>
          <BoxDialog>
            <Fab sx={{ ...(success && ButtonSx) }}>
              {success ? <Check style={{ color: "white" }} /> : <Save />}
            </Fab>
            {!success && (
              <CircularProgress size={68} sx={CircularProgressCSS} />
            )}
          </BoxDialog>
        </ContentDialog>
      </Dialog>
    </div>
  );
};
export default UpdateDialog;
